export default "/build/images/cc.png?fab4d78d6700d26dbe4e6ad214a7f447";